import React, { useEffect } from 'react'
import '@sendbird/uikit-react/dist/index.css'
import SendbirdProvider from '@sendbird/uikit-react/SendbirdProvider'
import { ChannelProvider } from '@sendbird/uikit-react/Channel/context'
import ChannelUISection from './ChannelUISection'
import { SendbirdUserResponse } from '../../types/sendbird/response/sendbird-user-response'
import Messages from './Messages'
import { RequestResponse } from '../../types/requests/responses/request-response'
import { useAudioPlayer } from 'react-use-audio-player'
import { UserResponse } from '../../types/users/user-response'

type Props = {
  user: SendbirdUserResponse
  chatChannelUrl: string
  customer?: UserResponse | null
  request?: RequestResponse
  size?: 'base' | 'large'
}

export default function MessagesSection({
  user,
  chatChannelUrl,
  customer,
  request,
  size = 'base',
}: Props) {
  const { load, play } = useAudioPlayer()
  useEffect(() => {
    load('/message-audio.mp3', {
      autoplay: false,
      html5: true,
    })
  }, [])

  if (!user) {
    return <div></div>
  }

  return (
    <div
      className={`h-[33rem] w-full opacity-99 ${
        size === 'base'
          ? 'small-size-message-window sm:w-96'
          : 'large-size-message-window md:w-96 lg:w-128'
      } xl:h-[33rem] 2xl:h-[33rem]`}
    >
      <SendbirdProvider
        appId={process.env.NEXT_PUBLIC_DEFAULT_SENDBIRD_KEY!}
        userId={user.userId}
        accessToken={user.accessToken}
        theme='dark'
      >
        <ChannelProvider
          isReactionEnabled={false}
          channelUrl={chatChannelUrl}
          disableUserProfile={true}
        >
          <ChannelUISection request={request} customer={customer} />
        </ChannelProvider>

        <Messages
          channelUrl={chatChannelUrl}
          play={() => {
            play()
          }}
        />
      </SendbirdProvider>
    </div>
  )
}
